import React, { useCallback } from "react";
import { Checkbox as AntdCheckbox, Tooltip } from "antd";
import ee from "../../../services/EventEmitter";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface Props {
  checked: boolean;
  entityKey: string;
  entityId: unknown;
  eventKey?: string;
  disabled?: boolean;
  tooltip?: string;
}

const Checkbox: React.FC<Props> = ({
  checked,
  entityKey,
  entityId,
  eventKey,
  disabled,
  tooltip,
}) => {
  const onChangeHandler = useCallback(
    (event: CheckboxChangeEvent) => {
      const { checked } = event.target;

      if (eventKey)
        ee.emit(eventKey, {
          entityId,
          entityKey,
          value: checked,
        });
    },
    [entityId, entityKey, eventKey]
  );

  if (tooltip) {
    return (
      <Tooltip placement="top" title={tooltip}>
        <AntdCheckbox
          onChange={onChangeHandler}
          disabled={disabled}
          checked={checked}
          key={entityKey}
        />
      </Tooltip>
    );
  }

  return (
    <AntdCheckbox
      onChange={onChangeHandler}
      disabled={disabled}
      checked={checked}
      key={entityKey}
    />
  );
};
export default Checkbox;
